// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckableTagGroup_container__MexxC","title":"CheckableTagGroup_title__kYopA"};